import React from 'react';
import Button from 'react-bootstrap/Button';
import { getStorageNodeTypeLabel } from '../../utils/storageTree';
import './StorageExplorerStyle.css';

/**
 * Path back out of the tree. Every ancestor is a link; the current place is text.
 *
 * @param {Object} props
 * @param {import('../../utils/storageTree').StorageNode[]} props.path - Root first, current last
 * @param {Function} props.onNavigate - (nodeId|null) => void; null goes to all rooms
 * @param {string} [props.rootLabel]
 */
const StorageBreadcrumb = ({ path = [], onNavigate, rootLabel = 'All rooms' }) => (
  <nav className="storage-breadcrumb" aria-label="Storage path">
    {path.length ? (
      <Button variant="link" onClick={() => onNavigate?.(null)}>
        {rootLabel}
      </Button>
    ) : (
      <span className="storage-breadcrumb__current">{rootLabel}</span>
    )}
    {path.map((node, index) => {
      const isCurrent = index === path.length - 1;
      return (
        <React.Fragment key={node.id}>
          <span className="storage-breadcrumb__sep" aria-hidden="true">
            ›
          </span>
          {isCurrent ? (
            <span
              className="storage-breadcrumb__current"
              aria-current="page"
              title={getStorageNodeTypeLabel(node)}
            >
              {node.name}
            </span>
          ) : (
            <Button variant="link" onClick={() => onNavigate?.(node.id)}>
              {node.name}
            </Button>
          )}
        </React.Fragment>
      );
    })}
  </nav>
);

export default StorageBreadcrumb;
